import {
  getSystemUsers,
  GetUserDetailsResponse,
} from "../../../services/accountService";
import { useQuery } from "@tanstack/react-query";

export default function useSystemUsersQuery() {
  return useQuery<GetUserDetailsResponse, string>(["systemUsers"], () =>
    getSystemUsers()
  );
}
